var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { MessageCircle, Plus, Search, Filter, AlertCircle, CheckCircle, Clock, XCircle, Loader2 } from 'lucide-react';
import { getMyFeedbacks } from '../actions/feedbacks';
import { showToast } from '../utils/toastUtils';
import FeedbackModal from '../components/common/FeedbackModal';
var FEEDBACK_TYPE_ICONS = {
    bug: '🐛',
    suggestion: '💡',
    question: '❓',
    problem: '⚠️',
    praise: '❤️',
    request: '📊',
};
var STATUS_COLORS = {
    pending: { bg: 'bg-yellow-500/20', text: 'text-yellow-400', icon: Clock },
    under_review: { bg: 'bg-blue-500/20', text: 'text-blue-400', icon: AlertCircle },
    in_progress: { bg: 'bg-purple-500/20', text: 'text-purple-400', icon: Loader2 },
    resolved: { bg: 'bg-green-500/20', text: 'text-green-400', icon: CheckCircle },
    rejected: { bg: 'bg-red-500/20', text: 'text-red-400', icon: XCircle },
};
var PRIORITY_COLORS = {
    low: 'text-green-400',
    medium: 'text-yellow-400',
    high: 'text-red-400',
};
var Feedbacks = function () {
    var navigate = useNavigate();
    var _a = useState([]), feedbacks = _a[0], setFeedbacks = _a[1];
    var _b = useState([]), filteredFeedbacks = _b[0], setFilteredFeedbacks = _b[1];
    var _c = useState(true), loading = _c[0], setLoading = _c[1];
    var _d = useState(''), searchTerm = _d[0], setSearchTerm = _d[1];
    var _e = useState('all'), statusFilter = _e[0], setStatusFilter = _e[1];
    var _f = useState('all'), typeFilter = _f[0], setTypeFilter = _f[1];
    var _g = useState(false), isModalOpen = _g[0], setIsModalOpen = _g[1];
    useEffect(function () {
        loadFeedbacks();
    }, []);
    useEffect(function () {
        filterFeedbacks();
    }, [feedbacks, searchTerm, statusFilter, typeFilter]);
    var loadFeedbacks = function () { return __awaiter(void 0, void 0, void 0, function () {
        var data, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, getMyFeedbacks()];
                case 2:
                    data = _a.sent();
                    setFeedbacks(data);
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _a.sent();
                    console.error('Erro ao carregar feedbacks:', error_1);
                    showToast('error', 'Erro ao carregar feedbacks');
                    return [3 /*break*/, 5];
                case 4:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var filterFeedbacks = function () {
        var filtered = __spreadArray([], feedbacks, true);
        // Filtro de busca
        if (searchTerm) {
            filtered = filtered.filter(function (f) {
                return f.title.toLowerCase().includes(searchTerm.toLowerCase());
            });
        }
        // Filtro de status
        if (statusFilter !== 'all') {
            filtered = filtered.filter(function (f) { return f.status === statusFilter; });
        }
        // Filtro de tipo
        if (typeFilter !== 'all') {
            filtered = filtered.filter(function (f) { return f.type === typeFilter; });
        }
        setFilteredFeedbacks(filtered);
    };
    var handleFeedbackClick = function (feedbackId) {
        navigate("/feedbacks/".concat(feedbackId));
    };
    var getTotalUnread = function () {
        return feedbacks.reduce(function (sum, f) { return sum + f.unread_admin_messages; }, 0);
    };
    if (loading) {
        return (React.createElement("div", { className: "min-h-screen bg-gray-900 flex items-center justify-center" },
            React.createElement("div", { className: "text-center" },
                React.createElement(Loader2, { size: 48, className: "animate-spin text-blue-500 mx-auto mb-4" }),
                React.createElement("p", { className: "text-gray-400" }, "Carregando feedbacks..."))));
    }
    return (React.createElement("div", { className: "min-h-screen bg-gray-900 p-6" },
        React.createElement("div", { className: "max-w-7xl mx-auto mb-6" },
            React.createElement("div", { className: "flex flex-col md:flex-row md:items-center md:justify-between gap-4" },
                React.createElement("div", null,
                    React.createElement("h1", { className: "text-3xl font-bold text-white flex items-center gap-3" },
                        React.createElement(MessageCircle, { size: 32, className: "text-green-400" }),
                        "Meus Feedbacks",
                        getTotalUnread() > 0 && (React.createElement("span", { className: "bg-red-500 text-white text-sm px-3 py-1 rounded-full" },
                            getTotalUnread(),
                            " nova",
                            getTotalUnread() > 1 ? 's' : '',
                            " mensagem",
                            getTotalUnread() > 1 ? 'ns' : ''))),
                    React.createElement("p", { className: "text-gray-400 mt-1" }, "Acompanhe suas solicita\u00E7\u00F5es, bugs reportados e sugest\u00F5es")),
                React.createElement("button", { onClick: function () { return setIsModalOpen(true); }, className: "bg-gradient-to-r from-green-500 to-blue-500 hover:from-green-600 hover:to-blue-600 text-white px-6 py-3 rounded-lg font-semibold flex items-center gap-2 shadow-lg transition" },
                    React.createElement(Plus, { size: 20 }),
                    "Novo Feedback"))),
        React.createElement("div", { className: "max-w-7xl mx-auto mb-6" },
            React.createElement("div", { className: "bg-gray-800 border border-gray-700 rounded-xl p-4" },
                React.createElement("div", { className: "grid grid-cols-1 md:grid-cols-3 gap-4" },
                    React.createElement("div", { className: "relative" },
                        React.createElement(Search, { size: 20, className: "absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" }),
                        React.createElement("input", { type: "text", placeholder: "Buscar por t\u00EDtulo...", value: searchTerm, onChange: function (e) { return setSearchTerm(e.target.value); }, className: "w-full bg-gray-700 text-white pl-10 pr-4 py-2 rounded-lg border border-gray-600 focus:outline-none focus:border-blue-400 transition" })),
                    React.createElement("div", { className: "relative" },
                        React.createElement(Filter, { size: 20, className: "absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" }),
                        React.createElement("select", { value: statusFilter, onChange: function (e) { return setStatusFilter(e.target.value); }, className: "w-full bg-gray-700 text-white pl-10 pr-4 py-2 rounded-lg border border-gray-600 focus:outline-none focus:border-blue-400 transition appearance-none" },
                            React.createElement("option", { value: "all" }, "Todos os Status"),
                            React.createElement("option", { value: "pending" }, "Pendente"),
                            React.createElement("option", { value: "under_review" }, "Em An\u00E1lise"),
                            React.createElement("option", { value: "in_progress" }, "Em Desenvolvimento"),
                            React.createElement("option", { value: "resolved" }, "Resolvido"),
                            React.createElement("option", { value: "rejected" }, "Rejeitado"))),
                    React.createElement("div", { className: "relative" },
                        React.createElement(Filter, { size: 20, className: "absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" }),
                        React.createElement("select", { value: typeFilter, onChange: function (e) { return setTypeFilter(e.target.value); }, className: "w-full bg-gray-700 text-white pl-10 pr-4 py-2 rounded-lg border border-gray-600 focus:outline-none focus:border-blue-400 transition appearance-none" },
                            React.createElement("option", { value: "all" }, "Todos os Tipos"),
                            React.createElement("option", { value: "bug" }, "\uD83D\uDC1B Bug Report"),
                            React.createElement("option", { value: "suggestion" }, "\uD83D\uDCA1 Sugest\u00E3o"),
                            React.createElement("option", { value: "question" }, "\u2753 D\u00FAvida"),
                            React.createElement("option", { value: "problem" }, "\u26A0\uFE0F Problema"),
                            React.createElement("option", { value: "praise" }, "\u2764\uFE0F Elogio"),
                            React.createElement("option", { value: "request" }, "\uD83D\uDCCA Solicita\u00E7\u00E3o")))))),
        React.createElement("div", { className: "max-w-7xl mx-auto" }, filteredFeedbacks.length === 0 ? (React.createElement("div", { className: "bg-gray-800 border border-gray-700 rounded-xl p-12 text-center" },
            React.createElement(MessageCircle, { size: 64, className: "text-gray-600 mx-auto mb-4" }),
            React.createElement("h3", { className: "text-xl font-semibold text-gray-400 mb-2" }, feedbacks.length === 0
                ? 'Nenhum feedback enviado ainda'
                : 'Nenhum feedback encontrado com os filtros aplicados'),
            React.createElement("p", { className: "text-gray-500 mb-6" }, feedbacks.length === 0
                ? 'Envie seu primeiro feedback clicando no botão acima'
                : 'Tente ajustar os filtros ou buscar por outro termo'),
            feedbacks.length === 0 && (React.createElement("button", { onClick: function () { return setIsModalOpen(true); }, className: "bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg font-semibold inline-flex items-center gap-2 transition" },
                React.createElement(Plus, { size: 20 }),
                "Enviar Primeiro Feedback")))) : (React.createElement("div", { className: "grid gap-4" }, filteredFeedbacks.map(function (feedback) {
            var _a;
            var StatusIcon = ((_a = STATUS_COLORS[feedback.status]) === null || _a === void 0 ? void 0 : _a.icon) || Clock;
            var statusStyle = STATUS_COLORS[feedback.status] || STATUS_COLORS.pending;
            return (React.createElement("div", { key: feedback.id, onClick: function () { return handleFeedbackClick(feedback.feedback_id); }, className: "bg-gray-800 border border-gray-700 rounded-xl p-5 hover:border-blue-500/50 hover:bg-gray-750 transition cursor-pointer group" },
                React.createElement("div", { className: "flex items-start justify-between gap-4" },
                    React.createElement("div", { className: "flex-1 min-w-0" },
                        React.createElement("div", { className: "flex items-center gap-3 mb-2" },
                            React.createElement("span", { className: "text-2xl" }, FEEDBACK_TYPE_ICONS[feedback.type]),
                            React.createElement("h3", { className: "text-lg font-semibold text-white group-hover:text-blue-400 transition truncate" }, feedback.title),
                            feedback.unread_admin_messages > 0 && (React.createElement("span", { className: "bg-red-500 text-white text-xs px-2 py-1 rounded-full font-bold flex-shrink-0 animate-pulse" },
                                feedback.unread_admin_messages,
                                " nova",
                                feedback.unread_admin_messages > 1 ? 's' : ''))),
                        React.createElement("div", { className: "flex flex-wrap items-center gap-3 text-sm" },
                            React.createElement("span", { className: "".concat(statusStyle.bg, " ").concat(statusStyle.text, " px-3 py-1 rounded-full font-semibold flex items-center gap-1") },
                                React.createElement(StatusIcon, { size: 14 }),
                                feedback.status_display),
                            React.createElement("span", { className: "".concat(PRIORITY_COLORS[feedback.priority], " font-semibold") },
                                "Prioridade: ",
                                feedback.priority_display),
                            React.createElement("span", { className: "text-gray-400 flex items-center gap-1" },
                                React.createElement(MessageCircle, { size: 14 }),
                                feedback.messages_count,
                                " mensagem",
                                feedback.messages_count !== 1 ? 's' : ''),
                            React.createElement("span", { className: "text-gray-500" }, new Date(feedback.created_at).toLocaleDateString('pt-BR', {
                                day: '2-digit',
                                month: '2-digit',
                                year: 'numeric',
                                hour: '2-digit',
                                minute: '2-digit'
                            })))),
                    React.createElement("div", { className: "text-gray-600 group-hover:text-blue-400 transition" }, "\u2192"))));
        })))),
        React.createElement(FeedbackModal, { isOpen: isModalOpen, onClose: function () {
                setIsModalOpen(false);
                loadFeedbacks(); // Recarrega lista após criar
            } })));
};
export default Feedbacks;
